import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import photo from "../../../assets/images/user4.jpg";
import { useLoader } from "../../../context/LoaderContext";
import useMobile from "../../../hooks/useMobile";
import useTab from "../../../hooks/useTab";
import {
  dynamicFailed,
  dynamicSuccess,
  failed,
  success,
} from "../../../hooks/useToast";
import axios from "axios";
import { headers, openLogin } from "../../../exports/exports";
import "yet-another-react-lightbox/plugins/captions.css";
import PersonalInformation from "../member/PersonalInformation";
import ContactInformation from "../member/ContactInformation";
import OperationInfromation from "../member/OperationInfromation";
import Uploads from "../member/Uploads";
import { checkUser, fetchUserById } from "../../../api/UserApi";
import { IMemberListData } from "../../../exports/interfaces";
import { useUserDataContext } from "../../../context/UserDataContext";
import { getFormattedDate } from "../../../exports/functions";
import StatusDropDown from "./StatusDropDown";
import StatusConfirmation from "./StatusConfirmation";

const EditMember = () => {
  const location = useLocation();
  const mobile = useMobile();
  const tab = useTab();
  const { setLoading } = useLoader();
  const [listMemberData, setListMemberData] = useState<IMemberListData[]>([]);
  const [openConfirmation, setOpenConfirmation] = useState<boolean>(false);
  const { userData, setUserData } = useUserDataContext();
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [setLoading]);

  const accessToken = localStorage.getItem("frcsit:access-token");
  useEffect(() => {
    setLoading(true);
    if (!userData) {
      if (accessToken === null || accessToken === undefined) {
        openLogin();
        return;
      }
      Promise.all([checkUser(accessToken)])
        .then(([userData]) => {
          setUserData(userData);
          // userData?.data?.status === "0" && navigate("/error");
          userData?.data?.roles[0]?.name !== "sa" && openLogin();
        })
        .catch(() => {
          dynamicFailed("Server Error");
        });
    }
  }, [accessToken, navigate, setLoading, setUserData, userData]);
  const memberDataId = location.state?.memberDataId;
  const getUserById = useCallback(() => {
    if (!memberDataId) return;
    fetchUserById(memberDataId)
      .then((data) => {
        setListMemberData(data);
        setTimeout(() => setLoading(false), 1000);
      })
      .catch(() => {
        dynamicFailed("Server Error");
        setTimeout(() => setLoading(false), 1000);
      });
  }, [memberDataId, setLoading]);
  useEffect(() => {
    if (userData) {
      getUserById();
    }
  }, [getUserById, setLoading, userData]);
  //   const { setLoading } = useLoader();
  //   const navigate = useNavigate();
  //   const mobile = useMobile();
  //   const tab = useTab();
  //   const fileInputRef = useRef<HTMLInputElement>(null);
  //   const [errors, setErrors] = useState<{ [key: string]: string }>({});
  //   const [preview, setPreview] = useState<string | null>(null);
  const [approvalStatus, setApprovalStatus] = useState<string>("");
  const [rejectionReason, setRejectionReason] = useState<string>("");
  const [previousStatus, setPreviousStatus] = useState<string>();

  //   const [firstname, setFirstname] = useState<string>("");
  //   const [middlename, setMiddlename] = useState<string>("");
  //   const [lastname, setLastname] = useState<string>("");
  //   const [designation, setDesignation] = useState<string>("");
  //   const [country, setCountry] = useState<string>("");
  //   const [qualifications, setQualifications] = useState<string>("");
  //   const [mobilenumber, setMobileNumber] = useState<string>("");
  //   const [email, setEmail] = useState<string>("");
  //   const [selectedProfileImage, setSelectedProfileImage] = useState<File>();
  //   const [membershipType, setMembershipType] = useState<string>("");
  //   const [membershipExpiry, setMembershipExpiry] = useState<number>(0);
  //   const [memberDescription, setMemberDescription] = useState<string>("");
  const [status, setStatus] = useState<string>("");

  const changeStatus = async () => {
    setLoading(true);
    setStatus(approvalStatus);
    const formattedDate = getFormattedDate(
      listMemberData[0]?.attributes?.Membership_Valid,
      0,
    );
    try {
      if (userData?.data?.roles[0]?.name === "sa") {
        const memberPayload: any = {
          Status: approvalStatus,
        };
        if (
          approvalStatus === "Active" &&
          listMemberData[0]?.attributes?.Membership_Valid !== 0
        ) {
          memberPayload.Membership_Expiry =
            listMemberData[0]?.attributes?.Membership_Expiry &&
            listMemberData[0]?.attributes?.Status === "Pending"
              ? new Date(
                  new Date(
                    listMemberData[0]?.attributes?.Membership_Expiry,
                  ).setFullYear(
                    new Date(
                      listMemberData[0]?.attributes?.Membership_Expiry,
                    ).getFullYear() + 1,
                  ),
                )
                  .toISOString()
                  .split("T")[0]
              : formattedDate;
          memberPayload.Payment_Received = false;
        }
        const updateRes = await axios.put(
          `${process.env.REACT_APP_strapiUrl}/api/frcsit-users/${listMemberData[0]?.id}`,
          { data: memberPayload },
          { headers },
        );

        if (updateRes?.status !== 200) {
          dynamicFailed("Status update failed.");
          setLoading(false);
          return;
        }

        // STEP 6: Send Notification
        const currentYear = getFormattedDate(0, 0).slice(0, 4);
        const fullName =
          `${listMemberData[0]?.attributes?.First_Name} ${listMemberData[0]?.attributes?.Middle_Name} ${listMemberData[0]?.attributes?.Last_Name}`
            .replace(/\s+/g, " ")
            .trim();
        const email = listMemberData[0]?.attributes?.Email;

        const notificationUser = {
          sisID: 1232,
          email,
        };

        const adminUsers = [
          {
              sisID: 1233,
              email: "frcsitsecretary@gmail.com",
            },
            {
              sisID: 1234,
              email: "secretary@frcsit.com",
            },
        ];

        if (previousStatus !== "Active" && approvalStatus === "Active") {
          const time = new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          });

          const oneMonthBefore = getFormattedDate(
            listMemberData[0]?.attributes?.Membership_Valid,
            0,
            1,
          );
          const oneWeekBefore = getFormattedDate(
            listMemberData[0]?.attributes?.Membership_Valid,
            7,
          );
          const oneDayBefore = getFormattedDate(
            listMemberData[0]?.attributes?.Membership_Valid,
            1,
          );

          await axios.post(
            `${process.env.REACT_APP_NOTIFICATION_URL}/scheduled-notification`,
            {
              sisOrganizationId: 80,
              payload: {
                FullName: fullName,
                MembershipType:
                  listMemberData[0]?.attributes?.Type_Of_Membership,
                ExpirationDate: formattedDate,
                CurrentYear: currentYear,
              },
              notificationTemplateId: "15246d73-2633-451f-bcb9-6a5751e4b21d",
              scheduledNotificationTime: time,
              scheduledNotificationDate: [
                oneMonthBefore,
                oneWeekBefore,
                oneDayBefore,
              ],
              scheduledNotificationReceivers: [notificationUser],
              scheduledNotificationSender: 5171,
            },
          );

          await axios.post(
            `${process.env.REACT_APP_NOTIFICATION_URL}/notification`,
            {
              templateId: "e5bbfc23-6037-4f2e-bc10-dcb42e4cb615",
              senderId: 5171,
              payload: {
                FullName: fullName,
                CurrentYear: currentYear,
              },
              users: [notificationUser],
            },
          );

          await axios.post(
            `${process.env.REACT_APP_NOTIFICATION_URL}/notification`,
            {
              templateId: "de2a60fb-1d8d-4f59-9592-582083fd9de7",
              senderId: 5171,
              payload: {
                FullName: fullName,
                CurrentYear: currentYear,
              },
              users: adminUsers,
            },
          );
        } else if (
          previousStatus !== "Approved" &&
          approvalStatus === "Approved"
        ) {
          await axios.post(
            `${process.env.REACT_APP_NOTIFICATION_URL}/notification`,
            {
              templateId: "ea1ad73b-67da-4590-ba4f-703fa8779954",
              senderId: 5171,
              payload: {
                FullName: fullName,
                CurrentYear: currentYear,
              },
              users: [notificationUser],
            },
          );

          await axios.post(
            `${process.env.REACT_APP_NOTIFICATION_URL}/notification`,
            {
              templateId: "814785d9-b935-4c94-bf24-71bb01cbe5ac",
              senderId: 5171,
              payload: {
                FullName: fullName,
                CurrentYear: currentYear,
              },
              users: adminUsers,
            },
          );

          await axios.post(
            `${process.env.REACT_APP_strapiUrl}/api/frcsit-notices`,
            {
              data: {
                Message:
                  "Your account has been approved. Please make the payment and upload the payment receipt from the Uploads tab.",
                Type: "status",
                bf_frcsit_user: listMemberData[0]?.id,
              },
            },
            { headers },
          );
        } else if (approvalStatus === "Rejected") {
          await axios.post(
            `${process.env.REACT_APP_NOTIFICATION_URL}/notification`,
            {
              templateId: "ef451502-86ba-4aec-9e41-9e330037b88d",
              senderId: 5171,
              payload: {
                FullName: fullName,
                reasonMessage: rejectionReason,
                CurrentYear: currentYear,
              },
              users: [notificationUser],
            },
          );

          await axios.post(
            `${process.env.REACT_APP_NOTIFICATION_URL}/notification`,
            {
              templateId: "7079dfc9-d164-4a02-a149-38bc959a5f87",
              senderId: 5171,
              payload: {
                FullName: fullName,
                reasonMessage: rejectionReason,
                CurrentYear: currentYear,
              },
              users: adminUsers,
            },
          );

          await axios.post(
            `${process.env.REACT_APP_strapiUrl}/api/frcsit-notices`,
            {
              data: {
                Message: rejectionReason,
                Type: "status",
                bf_frcsit_user: listMemberData[0]?.id,
              },
            },
            { headers },
          );
        }

        // STEP 7: Membership Expired
        if (approvalStatus === "Expired") {
          await axios.post(
            `${process.env.REACT_APP_strapiUrl}/api/frcsit-notices`,
            {
              data: {
                Message: "Your membership is expired.",
                Type: "status",
                bf_frcsit_user: listMemberData[0]?.id,
              },
            },
            { headers },
          );
        }

        if (approvalStatus === "Pending") {
          await axios.post(
            `${process.env.REACT_APP_strapiUrl}/api/frcsit-notices`,
            {
              data: {
                Message:
                  "Your account is under review. Please wait until it’s approved to make payment.",
                Type: "status",

                bf_frcsit_user: listMemberData[0]?.id,
              },
            },
            { headers },
          );
        }
      }
      getUserById();
      dynamicSuccess("Status updated successfully!");
    } catch (e: any) {
      dynamicFailed(`${e.message}`);
    } finally {
      setLoading(false);
    }
  };
  //   const token = localStorage.getItem("frcsit:access-token");
  //   const sisheaders = { Authorization: `Bearer ${token}` };

  //   const [open, setOpen] = useState(false);
  //   const [slides, setSlides] = useState<any[]>([]);

  //   const lightboxSlides = memberData?.attributes?.Payment_Reciept?.data
  //     ?.slice()
  //     .sort(
  //       (a: any, b: any) =>
  //         new Date(b?.attributes?.createdAt).getTime() -
  //         new Date(a?.attributes?.createdAt).getTime()
  //     )
  //     .map((item: any) => {
  //       const mimeType = item?.attributes?.mime;
  //       const url = item?.attributes?.url;
  //       const createdAt = item?.attributes?.createdAt;
  //       const nepalDate = new Date(
  //         new Date(createdAt).toLocaleString("en-US", {
  //           timeZone: "Asia/Kathmandu",
  //         })
  //       );
  //       const formattedDate = `${nepalDate.getFullYear()}-${String(
  //         nepalDate.getMonth() + 1
  //       ).padStart(2, "0")}-${String(nepalDate.getDate()).padStart(2, "0")}`;
  //       const timeString = `${String(nepalDate.getHours()).padStart(
  //         2,
  //         "0"
  //       )}:${String(nepalDate.getMinutes()).padStart(2, "0")}`;
  //       const formattedTime = formatTime(timeString);
  //       const formattedDateTime = `${formattedDate}, ${formattedTime}`;

  //       if (mimeType?.startsWith("image")) {
  //         return {
  //           type: "image",
  //           src: `${process.env.REACT_APP_strapiUrl}${url}`,
  //           description: (
  //             <div
  //               style={{
  //                 display: "flex",
  //                 alignItems: "center",
  //                 justifyContent: "space-between",
  //               }}
  //             >
  //               <span>{formattedDateTime}</span>
  //               <a
  //                 href={`${process.env.REACT_APP_strapiUrl}${url}`}
  //                 target="_blank"
  //                 rel="noopener noreferrer"
  //                 className="thm-btn main-header-two__btn custom-main-header-two__btn custom-donate-btn"
  //               >
  //                 View
  //               </a>
  //             </div>
  //           ),
  //         };
  //       }

  //       if (mimeType === "application/pdf") {
  //         return {
  //           type: "image",
  //           src: "https://cdn-icons-png.flaticon.com/512/4208/4208479.png",
  //           description: (
  //             <div
  //               style={{
  //                 display: "flex",
  //                 alignItems: "center",
  //                 justifyContent: "space-between",
  //               }}
  //             >
  //               <span>{formattedDate}</span>
  //               <a
  //                 href={`${process.env.REACT_APP_strapiUrl}${url}`}
  //                 target="_blank"
  //                 rel="noopener noreferrer"
  //                 className="thm-btn main-header-two__btn custom-main-header-two__btn custom-donate-btn"
  //               >
  //                 View
  //               </a>
  //             </div>
  //           ),
  //         };
  //       }

  //       return null;
  //     })
  //     .filter(Boolean);

  //   const documentSlides = Object.entries(
  //     memberData?.attributes?.bi_frcsit_user_upload?.data?.attributes || {}
  //   )
  //     .map(([key, value]: [string, any]) => {
  //       const fileData = value?.data;
  //       if (!fileData || !fileData?.attributes?.url) return null;

  //       const { mime, url } = fileData.attributes;
  //       const label = key.replace(/_/g, " ");

  //       const description = (
  //         <div
  //           style={{
  //             display: "flex",
  //             justifyContent: "space-between",
  //             alignItems: "center",
  //             fontSize: "14px",
  //           }}
  //         >
  //           <strong>{label}</strong>
  //           <a
  //             href={`${process.env.REACT_APP_strapiUrl}${url}`}
  //             target="_blank"
  //             rel="noopener noreferrer"
  //             className="thm-btn main-header-two__btn custom-main-header-two__btn custom-donate-btn"
  //           >
  //             View
  //           </a>
  //         </div>
  //       );

  //       if (mime?.startsWith("image")) {
  //         return {
  //           type: "image",
  //           src: `${process.env.REACT_APP_strapiUrl}${url}`,
  //           description,
  //         };
  //       }

  //       if (mime === "application/pdf") {
  //         return {
  //           type: "image",
  //           src: "https://cdn-icons-png.flaticon.com/512/4208/4208479.png",
  //           description,
  //         };
  //       }

  //       return null;
  //     })
  //     .filter(Boolean);

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [setLoading]);

  //   useEffect(() => {
  //     setFirstname(memberData?.attributes?.First_Name);
  //     setMiddlename(memberData?.attributes?.Middle_Name);
  //     setLastname(memberData?.attributes?.Last_Name);
  //     setDesignation(memberData?.attributes?.Designation);
  //     setCountry(memberData?.attributes?.Country);
  //     setQualifications(memberData?.attributes?.Qualifications);
  //     setMobileNumber(memberData?.attributes?.Mobile_Number);
  //     setEmail(memberData?.attributes?.Email);
  //     setMembershipType(memberData?.attributes?.Type_Of_Membership);
  //     setStatus(memberData?.attributes?.Status);
  //     setPreviousStatus(memberData?.attributes?.Status);
  //     setApprovalStatus(memberData?.attributes?.Status);
  //     setMemberDescription(memberData?.attributes?.Description);
  //     setMembershipExpiry(memberData?.attributes?.Membership_Valid);
  //   }, [memberData]);

  //   const handleEditClick = () => {
  //     fileInputRef.current?.click();
  //   };

  //   const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
  //     const file = e.target.files?.[0];
  //     if (file) {
  //       const url = URL.createObjectURL(file);
  //       setPreview(url);
  //       setSelectedProfileImage(file);
  //     }
  //   };

  //   const isValidEmail = (email: string) => /\S+@\S+\.\S+/.test(email);
  //   const validateStep = () => {
  //     let newErrors: { [key: string]: string } = {};
  //     if (!firstname) newErrors.firstname = "First Name is required";
  //     if (!designation) newErrors.designation = "Designation is required";
  //     if (!country) newErrors.country = "Location is required";
  //     if (!qualifications)
  //       newErrors.qualifications = "Specialization are required";
  //     if (!mobilenumber) {
  //       newErrors.mobilenumber = "Phone Number is required";
  //     } else if (!/^\d{10}$/.test(mobilenumber)) {
  //       newErrors.mobilenumber = "Phone Number must be exactly 10 digits";
  //     }
  //     if (!email) newErrors.email = "Email is required";
  //     else if (!isValidEmail(email)) newErrors.email = "Invalid email format";
  //     setErrors(newErrors);
  //     return Object.keys(newErrors).length === 0;
  //   };
  //   const handleSubmit = async () => {
  //     if (!validateStep()) return;

  //     setLoading(true);
  //     let uploadedImageId: number | null = null;
  //     const formattedDate = getFormattedDate(membershipExpiry, 0);

  //     try {
  //       // STEP 1: Create Location
  //       const locationDetail = {
  //         area_name: "Chhauni",
  //         street_name: "Kakancho Binayak Marg",
  //         nearest_landmark: "",
  //         municipalities_id: 332,
  //         district_id: 28,
  //         province_id: 3,
  //       };

  //       const locationRes = await axios.post(
  //         `${process.env.REACT_APP_locationUrl}/location`,
  //         locationDetail,
  //         { headers: sisheaders }
  //       );

  //       // STEP 2: Update Identity User
  //       const userDetail = {
  //         name: firstname,
  //         phone_no: mobilenumber,
  //         address: JSON.stringify({
  //           area_name: { id: locationRes?.data?.area_id },
  //           street_name: { id: locationRes?.data?.street_id },
  //           nearest_landmark: "",
  //           municipalities_id: 332,
  //           district_id: 28,
  //           province_id: 3,
  //         }),
  //         email,
  //         gender: memberData?.attributes?.Sex === "male" ? 1 : 2,
  //         dob: "2000-01-01T00:00:00+05:45",
  //         status: status === "Active" ? 1 : 0,
  //         roles: ["member"],
  //         profile_pic: null,
  //       };

  //       const identityRes = await axios.put(
  //         `${process.env.REACT_APP_IDENTITY_SERVER_URL}api/admin/users/${memberData?.attributes?.sis_id}`,
  //         userDetail,
  //         { headers: sisheaders }
  //       );

  //       if (identityRes?.status !== 200) {
  //         dynamicFailed("Identity update failed.");
  //         setLoading(false);
  //         return;
  //       }

  //       // STEP 3: Upload Profile Image (if selected)
  //       if (selectedProfileImage) {
  //         try {
  //           const formData = new FormData();
  //           formData.append("files", selectedProfileImage);

  //           const uploadRes = await axios.post(
  //             `${process.env.REACT_APP_strapiUrl}/api/upload`,
  //             formData,
  //             {
  //               headers: {
  //                 Authorization: headers.Authorization,
  //                 "Content-Type": "multipart/form-data",
  //               },
  //             }
  //           );

  //           if (!uploadRes?.data?.[0]?.id)
  //             throw new Error("Image upload failed.");
  //           uploadedImageId = uploadRes.data[0].id;
  //         } catch (error) {
  //           dynamicFailed("Profile picture upload failed.");
  //           setLoading(false);
  //           return;
  //         }
  //       }

  //       // STEP 4: Prepare Strapi user update data
  //       const memberPayload: any = {
  //         Email: email,
  //         First_Name: firstname,
  //         Last_Name: lastname,
  //         Designation: designation,
  //         Qualifications: qualifications,
  //         Mobile_Number: mobilenumber,
  //         Country: country,
  //         Status: status,
  //         Description: memberDescription,
  //       };

  //       if (uploadedImageId) memberPayload.Profile_Picture = uploadedImageId;

  //       if (
  //         approvalStatus === "Active" &&
  //         memberData?.attributes?.Membership_Valid !== 0
  //       ) {
  //         memberPayload.Membership_Expiry =
  //           memberData?.attributes?.Membership_Expiry &&
  //           memberData?.attributes?.Status === "Pending"
  //             ? new Date(
  //                 new Date(memberData?.attributes?.Membership_Expiry).setFullYear(
  //                   new Date(
  //                     memberData?.attributes?.Membership_Expiry
  //                   ).getFullYear() + 1
  //                 )
  //               )
  //                 .toISOString()
  //                 .split("T")[0]
  //             : formattedDate;
  //         memberPayload.Payment_Received = false;
  //       }

  //       // STEP 5: Update Strapi User
  //       const updateRes = await axios.put(
  //         `${process.env.REACT_APP_strapiUrl}/api/frcsit-users/${memberData?.id}`,
  //         { data: memberPayload },
  //         { headers }
  //       );

  //       if (updateRes?.status !== 200) {
  //         dynamicFailed("User update failed.");
  //         setLoading(false);
  //         return;
  //       }

  //       // STEP 6: Send Notification
  //       const currentYear = getFormattedDate(0, 0).slice(0, 4);
  //       const fullName = `${firstname} ${middlename} ${lastname}`
  //         .replace(/\s+/g, " ")
  //         .trim();

  //       const notificationUser = {
  //         sisID: 1232,
  //         email,
  //       };

  //       if (previousStatus !== "Active" && approvalStatus === "Active") {
  //         const time = new Date().toLocaleTimeString([], {
  //           hour: "2-digit",
  //           minute: "2-digit",
  //           hour12: false,
  //         });

  //         const oneMonthBefore = getFormattedDate(membershipExpiry, 0, 1);
  //         const oneWeekBefore = getFormattedDate(membershipExpiry, 7);
  //         const oneDayBefore = getFormattedDate(membershipExpiry, 1);

  //         await axios.post(
  //           `${process.env.REACT_APP_NOTIFICATION_URL}/scheduled-notification`,
  //           {
  //             sisOrganizationId: 80,
  //             payload: {
  //               FullName: fullName,
  //               MembershipType: membershipType,
  //               ExpirationDate: formattedDate,
  //               CurrentYear: currentYear,
  //             },
  //             notificationTemplateId: "15246d73-2633-451f-bcb9-6a5751e4b21d",
  //             scheduledNotificationTime: time,
  //             scheduledNotificationDate: [
  //               oneMonthBefore,
  //               oneWeekBefore,
  //               oneDayBefore,
  //             ],
  //             scheduledNotificationReceivers: [notificationUser],
  //             scheduledNotificationSender: 5171,
  //           }
  //         );

  //         await axios.post(
  //           `${process.env.REACT_APP_NOTIFICATION_URL}/notification`,
  //           {
  //             templateId: "e5bbfc23-6037-4f2e-bc10-dcb42e4cb615",
  //             senderId: 5171,
  //             payload: {
  //               FullName: fullName,
  //               CurrentYear: currentYear,
  //             },
  //             users: [notificationUser],
  //           }
  //         );
  //       } else if (previousStatus !== "Approve" && approvalStatus === "Approve") {
  //         await axios.post(
  //           `${process.env.REACT_APP_NOTIFICATION_URL}/notification`,
  //           {
  //             templateId: "ea1ad73b-67da-4590-ba4f-703fa8779954",
  //             senderId: 5171,
  //             payload: {
  //               FullName: fullName,
  //               CurrentYear: currentYear,
  //             },
  //             users: [notificationUser],
  //           }
  //         );

  //         await axios.post(
  //           `${process.env.REACT_APP_strapiUrl}/api/frcsit-notices`,
  //           {
  //             data: {
  //               Message:
  //                 "Your account has been approved. Please make the payment and upload the payment receipt.",
  //               Type: "status",
  //               bf_frcsit_user: memberData?.id,
  //             },
  //           },
  //           { headers }
  //         );
  //       } else if (approvalStatus === "Rejected") {
  //         await axios.post(
  //           `${process.env.REACT_APP_NOTIFICATION_URL}/notification`,
  //           {
  //             templateId: "ef451502-86ba-4aec-9e41-9e330037b88d",
  //             senderId: 5171,
  //             payload: {
  //               FullName: fullName,
  //               reasonMessage: rejectionReason,
  //               CurrentYear: currentYear,
  //             },
  //             users: [notificationUser],
  //           }
  //         );

  //         await axios.post(
  //           `${process.env.REACT_APP_strapiUrl}/api/frcsit-notices`,
  //           {
  //             data: {
  //               Message: rejectionReason,
  //               Type: "status",
  //               bf_frcsit_user: memberData?.id,
  //             },
  //           },
  //           { headers }
  //         );
  //       }

  //       // STEP 7: Membership Expired
  //       if (status === "Expired") {
  //         await axios.post(
  //           `${process.env.REACT_APP_strapiUrl}/api/frcsit-notices`,
  //           {
  //             data: {
  //               Message: "Your membership is expired.",
  //               Type: "status",
  //               bf_frcsit_user: memberData?.id,
  //             },
  //           },
  //           { headers }
  //         );
  //       }

  //       if (status === "Pending") {
  //         await axios.post(
  //           `${process.env.REACT_APP_strapiUrl}/api/frcsit-notices`,
  //           {
  //             data: {
  //               Message:
  //                 "Your account is under review. Please wait until it’s approved.",
  //               Type: "status",
  //               bf_frcsit_user: memberData?.id,
  //             },
  //           },
  //           { headers }
  //         );
  //       }

  //       setPreviousStatus(approvalStatus);
  //       setRejectionReason("");
  //       dynamicSuccess("Profile Updated successfully!");
  //     } catch (e) {
  //       dynamicFailed("Something went wrong. Please try again.");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   return (
  //     <>
  //       <section
  //         className="events-page"
  //         style={{
  //           padding: "0px 0px 20px 0px",
  //           // marginTop: (!mobile && !tab) ? "88px" : "unset",
  //           marginLeft: !mobile && !tab ? "240px" : "unset",
  //         }}
  //       >
  //         <div className="container">
  //           <div
  //             className="section-title custom-text-center"
  //             style={{ marginBottom: "unset" }}
  //           >
  //             <h2 className="section-title__title custom-user-section-title">
  //               Edit Member
  //             </h2>
  //           </div>

  //           <div className="row">
  //             <div
  //               className="col-xl-12"
  //               style={{ marginTop: mobile || tab ? "10px" : "unset" }}
  //             >
  //               <div className="quality-work__tab-box tabs-box">
  //                 <div
  //                   className="custom-feature-two"
  //                   style={{ padding: "16px", backgroundColor: "transparent" }}
  //                 >
  //                   <div className="row">
  //                     <div className="user-card__header">
  //                       <div
  //                         className="user-card__info"
  //                         style={{ marginLeft: "unset", textAlign: "end" }}
  //                       >
  //                         <button
  //                           onClick={() => navigate(-1)}
  //                           className="thm-btn become-volunteer__btn"
  //                         >
  //                           <i className="icon-arrow-left2"></i>
  //                           Back
  //                         </button>
  //                       </div>
  //                     </div>
  //                     <hr />
  //                     <div className="col-xl-6">
  //                       <div className="become-volunteer__input">
  //                         <span>Member First Name *</span>
  //                         <input
  //                           type="text"
  //                           placeholder="First Name*"
  //                           name="firstname"
  //                           value={firstname}
  //                           onChange={(e) => setFirstname(e.target.value)}
  //                           className={errors.firstname && "error-border"}
  //                         />
  //                         {errors.firstname && (
  //                           <p className="error-message">{errors.firstname}</p>
  //                         )}
  //                       </div>
  //                     </div>
  //                     <div className="col-xl-6">
  //                       <div className="become-volunteer__input">
  //                         <span>Designation *</span>
  //                         <input
  //                           type="text"
  //                           placeholder="Designation*"
  //                           name="designation"
  //                           value={designation}
  //                           onChange={(e) => setDesignation(e.target.value)}
  //                           className={errors.designation && "error-border"}
  //                         />
  //                         {errors.designation && (
  //                           <p className="error-message">{errors.designation}</p>
  //                         )}
  //                       </div>
  //                     </div>
  //                     <div className="col-xl-6">
  //                       <div className="become-volunteer__input">
  //                         <span>Member Last Name *</span>
  //                         <input
  //                           type="text"
  //                           placeholder="Last Name*"
  //                           name="lastname"
  //                           value={lastname}
  //                           onChange={(e) => setLastname(e.target.value)}
  //                           className={errors.lastname && "error-border"}
  //                         />
  //                         {errors.lastname && (
  //                           <p className="error-message">{errors.lastname}</p>
  //                         )}
  //                       </div>
  //                     </div>
  //                     <div className="col-xl-6">
  //                       <div className="become-volunteer__input">
  //                         <span>Location *</span>
  //                         <input
  //                           type="text"
  //                           placeholder="Location*"
  //                           name="location"
  //                           value={country}
  //                           onChange={(e) => setCountry(e.target.value)}
  //                           className={errors.lastname && "error-border"}
  //                         />
  //                         {errors.country && (
  //                           <p className="error-message">{errors.country}</p>
  //                         )}
  //                       </div>
  //                     </div>
  //                     <div className="col-xl-6">
  //                       <div className="become-volunteer__input">
  //                         <span>Specialization *</span>
  //                         <input
  //                           type="text"
  //                           placeholder="Specialization*"
  //                           name="specialization"
  //                           value={qualifications}
  //                           onChange={(e) => setQualifications(e.target.value)}
  //                           className={errors.qualifications && "error-border"}
  //                         />
  //                         {errors.qualifications && (
  //                           <p className="error-message">
  //                             {errors.qualifications}
  //                           </p>
  //                         )}
  //                       </div>
  //                     </div>
  //                     <div className="col-xl-6">
  //                       <div className="become-volunteer__input">
  //                         <span>Phone No. *</span>
  //                         <input
  //                           type="number"
  //                           placeholder="Phone No.*"
  //                           name="phoneno"
  //                           value={mobilenumber}
  //                           onChange={(e) => setMobileNumber(e.target.value)}
  //                           className={errors.mobilenumber && "error-border"}
  //                         />
  //                         {errors.mobilenumber && (
  //                           <p className="error-message">{errors.mobilenumber}</p>
  //                         )}
  //                       </div>
  //                     </div>
  //                     <div className="col-xl-6">
  //                       <div className="become-volunteer__input">
  //                         <span>Email *</span>
  //                         <input
  //                           type="text"
  //                           placeholder="Email*"
  //                           name="email"
  //                           value={email}
  //                           onChange={(e) => setEmail(e.target.value)}
  //                           className={errors.email && "error-border"}
  //                         />
  //                         {errors.email && (
  //                           <p className="error-message">{errors.email}</p>
  //                         )}
  //                       </div>
  //                     </div>
  //                     <div className="col-xl-6">
  //                       <div className="become-volunteer__input">
  //                         <span>Status *</span>
  //                         <div
  //                           style={{
  //                             display: "flex",
  //                             flexWrap: "wrap",
  //                             gap: "10px",
  //                             marginTop: "8px",
  //                             marginBottom:
  //                               approvalStatus === "Rejected" ? "8px" : "unset",
  //                           }}
  //                         >
  //                           <FormControlLabel
  //                             value="Pending"
  //                             control={
  //                               <Radio
  //                                 checked={status === "Pending"}
  //                                 onChange={() => {
  //                                   setStatus("Pending");
  //                                   setApprovalStatus("");
  //                                 }}
  //                                 sx={{
  //                                   color:
  //                                     status === "Pending" ? "yellow" : "gray",
  //                                   "&.Mui-checked": {
  //                                     color: "yellow",
  //                                   },
  //                                 }}
  //                               />
  //                             }
  //                             label="Pending"
  //                             sx={{
  //                               border: `1px solid ${
  //                                 status === "Pending" ? "yellow" : "#ccc"
  //                               }`,
  //                               borderRadius: "5px",
  //                               padding: "2px 10px",
  //                               color: status === "Pending" ? "yellow" : "gray",
  //                               backgroundColor: "transparent",
  //                               marginLeft: "unset",
  //                               marginRight: "unset",
  //                             }}
  //                           />

  //                           <FormControlLabel
  //                             value="Approve"
  //                             control={
  //                               <Radio
  //                                 checked={status === "Approve"}
  //                                 onChange={() => {
  //                                   // setStatus("Activate");
  //                                   setStatus("Approve");
  //                                   setApprovalStatus("Approve");
  //                                 }}
  //                                 sx={{
  //                                   color:
  //                                     status === "Approve" ? "green" : "gray",
  //                                   "&.Mui-checked": {
  //                                     color: "green",
  //                                   },
  //                                 }}
  //                               />
  //                             }
  //                             label="Approve"
  //                             sx={{
  //                               border: `1px solid ${
  //                                 status === "Approve" ? "green" : "#ccc"
  //                               }`,
  //                               borderRadius: "5px",
  //                               padding: "2px 10px",
  //                               color: status === "Approve" ? "green" : "gray",
  //                               backgroundColor: "transparent",
  //                               marginLeft: "unset",
  //                               marginRight: "unset",
  //                             }}
  //                           />

  //                           <FormControlLabel
  //                             value="Active"
  //                             control={
  //                               <Radio
  //                                 checked={status === "Active"}
  //                                 onChange={() => {
  //                                   // setStatus("Activate");
  //                                   setStatus("Active");
  //                                   setApprovalStatus("Active");
  //                                 }}
  //                                 sx={{
  //                                   color: status === "Active" ? "green" : "gray",
  //                                   "&.Mui-checked": {
  //                                     color: "green",
  //                                   },
  //                                 }}
  //                               />
  //                             }
  //                             label="Active"
  //                             sx={{
  //                               border: `1px solid ${
  //                                 status === "Active" ? "green" : "#ccc"
  //                               }`,
  //                               borderRadius: "5px",
  //                               padding: "2px 10px",
  //                               color: status === "Active" ? "green" : "gray",
  //                               backgroundColor: "transparent",
  //                               marginLeft: "unset",
  //                               marginRight: "unset",
  //                             }}
  //                           />

  //                           <FormControlLabel
  //                             value="Rejected"
  //                             control={
  //                               <Radio
  //                                 checked={status === "Rejected"}
  //                                 onChange={() => {
  //                                   setStatus("Rejected");
  //                                   // setStatus("Reject");
  //                                   setApprovalStatus("Rejected");
  //                                 }}
  //                                 sx={{
  //                                   color: status === "Rejected" ? "red" : "gray",
  //                                   "&.Mui-checked": {
  //                                     color: "red",
  //                                   },
  //                                 }}
  //                               />
  //                             }
  //                             label="Rejected"
  //                             sx={{
  //                               border: `1px solid ${
  //                                 status === "Rejected" ? "red" : "#ccc"
  //                               }`,
  //                               borderRadius: "5px",
  //                               padding: "2px 10px",
  //                               color: status === "Rejected" ? "red" : "gray",
  //                               backgroundColor: "transparent",
  //                               marginLeft: "unset",
  //                               marginRight: "unset",
  //                             }}
  //                           />
  //                           <FormControlLabel
  //                             value="Expired"
  //                             control={
  //                               <Radio
  //                                 checked={status === "Expired"}
  //                                 onChange={() => {
  //                                   setStatus("Expired");
  //                                   // setStatus("Expire");
  //                                   setApprovalStatus("");
  //                                 }}
  //                                 sx={{
  //                                   color:
  //                                     status === "Expired" ? "darkred" : "gray",
  //                                   "&.Mui-checked": {
  //                                     color: "darkred",
  //                                   },
  //                                 }}
  //                               />
  //                             }
  //                             label="Expired"
  //                             sx={{
  //                               border: `1px solid ${
  //                                 status === "Expired" ? "darkred" : "#ccc"
  //                               }`,
  //                               borderRadius: "5px",
  //                               padding: "2px 10px",
  //                               color: status === "Expired" ? "darkred" : "gray",
  //                               backgroundColor: "transparent",
  //                               marginLeft: "unset",
  //                               marginRight: "unset",
  //                             }}
  //                           />
  //                         </div>
  //                         {approvalStatus === "Rejected" && (
  //                           <div className="col-xl-12">
  //                             <div
  //                               className="become-volunteer__input become-volunteer__message-box"
  //                               style={{ height: "100px" }}
  //                             >
  //                               <textarea
  //                                 name="reason"
  //                                 placeholder="Reason For Rejection"
  //                                 value={rejectionReason}
  //                                 onChange={(e) =>
  //                                   setRejectionReason(e.target.value)
  //                                 }
  //                                 style={{ height: "100px" }}
  //                               ></textarea>
  //                             </div>
  //                           </div>
  //                         )}
  //                       </div>
  //                     </div>
  //                     <div className="col-xl-6">
  //                       <div className="become-volunteer__input custom-file-input">
  //                         <span>Profile Image</span>
  //                         {preview ? (
  //                           <>
  //                             <div
  //                               className="user-card__image"
  //                               style={{ cursor: "default" }}
  //                             >
  //                               <img src={preview} alt="User" />
  //                               <div
  //                                 className="edit-profil-pic-icon"
  //                                 style={{ top: "23px", left: "65px" }}
  //                                 onClick={handleEditClick}
  //                               >
  //                                 <span className="icon-pencil"></span>
  //                               </div>
  //                             </div>
  //                             <input
  //                               type="file"
  //                               accept="image/*"
  //                               ref={fileInputRef}
  //                               style={{ display: "none" }}
  //                               onChange={handleFileChange}
  //                             />
  //                           </>
  //                         ) : memberData?.attributes?.Profile_Picture?.data ? (
  //                           <>
  //                             <div
  //                               className="user-card__image"
  //                               style={{ cursor: "default" }}
  //                             >
  //                               <img
  //                                 src={`${process.env.REACT_APP_strapiUrl}${memberData.attributes.Profile_Picture.data.attributes.url}`}
  //                                 alt="User"
  //                               />
  //                               <div
  //                                 className="edit-profil-pic-icon"
  //                                 style={{ top: "23px", left: "65px" }}
  //                                 onClick={handleEditClick}
  //                               >
  //                                 <span className="icon-pencil"></span>
  //                               </div>
  //                             </div>
  //                             <input
  //                               type="file"
  //                               accept="image/*"
  //                               ref={fileInputRef}
  //                               style={{ display: "none" }}
  //                               onChange={handleFileChange}
  //                             />
  //                           </>
  //                         ) : (
  //                           <>
  //                             <label
  //                               htmlFor="profile-image-upload"
  //                               style={{ cursor: "pointer" }}
  //                             >
  //                               {"Upload Image"}
  //                             </label>
  //                             <input
  //                               type="file"
  //                               id="profile-image-upload"
  //                               accept=".png,.jpg,.jpeg"
  //                               onChange={handleFileChange}
  //                               style={{ display: "none" }}
  //                             />
  //                           </>
  //                         )}
  //                       </div>
  //                     </div>
  //                     <div className="col-xl-6">
  //                       <div className="become-volunteer__input">
  //                         <span>Membership Type</span>
  //                         <input
  //                           type="text"
  //                           placeholder="Membership Type"
  //                           name="membershiptype"
  //                           value={membershipType}
  //                           disabled
  //                         />
  //                       </div>
  //                     </div>
  //                     <div className="col-xl-6">
  //                       <div
  //                         className="become-volunteer__input"
  //                         style={{ display: "flex", gap: "10px" }}
  //                       >
  //                         <label
  //                           onClick={() => {
  //                             setSlides(documentSlides);
  //                             setOpen(true);
  //                           }}
  //                           className="thm-btn welcome-one__btn"
  //                           style={{ cursor: "pointer" }}
  //                         >
  //                           View Documents
  //                         </label>
  //                         <label
  //                           onClick={() => {
  //                             setSlides(lightboxSlides);
  //                             setOpen(true);
  //                           }}
  //                           className="thm-btn welcome-one__btn"
  //                           style={{ cursor: "pointer" }}
  //                         >
  //                           View Receipt
  //                         </label>
  //                       </div>
  //                     </div>
  //                     <div className="col-xl-12">
  //                       <div className="become-volunteer__input become-volunteer__message-box">
  //                         <span>Member Description</span>
  //                         <textarea
  //                           name="memberdescription"
  //                           placeholder="Member Description"
  //                           value={memberDescription}
  //                           onChange={(e) => setMemberDescription(e.target.value)}
  //                         ></textarea>
  //                       </div>
  //                     </div>
  //                   </div>
  //                   <div
  //                     className="become-volunteer__btn-box"
  //                     style={{ textAlign: "center", marginTop: "10px" }}
  //                   >
  //                     <button
  //                       type="submit"
  //                       className="thm-btn become-volunteer__btn"
  //                       onClick={() => handleSubmit()}
  //                     >
  //                       Update Member
  //                     </button>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       </section>
  //       <Lightbox
  //         open={open}
  //         close={() => setOpen(false)}
  //         slides={slides}
  //         plugins={[Counter, Zoom, Thumbnails, Captions]}
  //       />
  //     </>
  //   );
  // };
  const fileInputRef = useRef<HTMLInputElement>(null);
  const profilePicData = listMemberData[0]?.attributes?.Profile_Picture?.data;
  const [memberId, setMemberId] = useState<number>(0);
  const [activeTab, setActiveTab] = useState<string>("personal");
  const [firstname, setFirstname] = useState<string>("");
  const [middlename, setMiddlename] = useState<string>("");
  const [lastname, setLastname] = useState<string>("");
  const [age, setAge] = useState<number | null>(null);
  const [sex, setSex] = useState<string>("");
  const [designation, setDesignation] = useState<string>("");
  const [qualifications, setQualifications] = useState<string>("");
  const [professionalAffiliations, setProfessionalAffiliations] =
    useState<string>("");
  const [mobilenumber, setMobileNumber] = useState<string>("");
  const [whatsappnumber, setWhatsappNumber] = useState<string>("");
  const [permanentAddress, setPermanentAddress] = useState<string>("");
  const [city, setCity] = useState<string>("");
  const [stateProvince, setStateProvince] = useState<string>("");
  const [postalZipCode, setPostalZipCode] = useState<number | null>(null);
  const [country, setCountry] = useState<string>("");
  const [workAddress, setWorkAddress] = useState<string>("");
  const [workCity, setWorkCity] = useState<string>("");
  const [workStateProvince, setWorkStateProvince] = useState<string>("");
  const [workPostalZipCode, setWorkPostalZipCode] = useState<number | null>(
    null,
  );
  const [workCountry, setWorkCountry] = useState<string>("");

  useEffect(() => {
    setFirstname(listMemberData[0]?.attributes?.First_Name);
    setMiddlename(listMemberData[0]?.attributes?.Middle_Name);
    setLastname(listMemberData[0]?.attributes?.Last_Name);
    setAge(listMemberData[0]?.attributes?.Age);
    setSex(listMemberData[0]?.attributes?.Sex);
    setDesignation(listMemberData[0]?.attributes?.Designation);
    setQualifications(listMemberData[0]?.attributes?.Qualifications);
    setProfessionalAffiliations(
      listMemberData[0]?.attributes?.Professional_Affiliations,
    );
    setMobileNumber(listMemberData[0]?.attributes?.Mobile_Number);
    setWhatsappNumber(listMemberData[0]?.attributes?.WhatsAPP_Number);
    setPermanentAddress(listMemberData[0]?.attributes?.Permanent_Address);
    setCity(listMemberData[0]?.attributes?.City);
    setStateProvince(listMemberData[0]?.attributes?.State_Province);
    setPostalZipCode(listMemberData[0]?.attributes?.Postal_Zip_Code);
    setCountry(listMemberData[0]?.attributes?.Country);
    setWorkAddress(listMemberData[0]?.attributes?.Work_Address);
    setWorkCity(listMemberData[0]?.attributes?.Work_City);
    setWorkStateProvince(listMemberData[0]?.attributes?.Work_State_Province);
    setWorkPostalZipCode(listMemberData[0]?.attributes?.Work_Postal_Zip_Code);
    setWorkCountry(listMemberData[0]?.attributes?.Work_Country);
    setMemberId(listMemberData[0]?.id);
    setStatus(listMemberData[0]?.attributes?.Status);
    setPreviousStatus(listMemberData[0]?.attributes?.Status);
    setApprovalStatus(listMemberData[0]?.attributes?.Status);
  }, [listMemberData]);

  const handleEditClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("files", file);

      const uploadRes = await axios.post(
        `${process.env.REACT_APP_strapiUrl}/api/upload`,
        formData,
        {
          headers: {
            Authorization: headers.Authorization,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      const uploadedImageId = uploadRes.data[0].id;
      const data = {
        data: {
          Profile_Picture: uploadedImageId,
        },
      };

      const userRes = await axios.put(
        `${process.env.REACT_APP_strapiUrl}/api/frcsit-users/${memberId}`,
        data,
        {
          headers,
        },
      );
      if (userRes?.status === 200 || userRes?.status === 201) {
        getUserById();
        success();
      }
    } catch (error) {
      failed();
    }
  };

  return (
    <section
      className="quality-work"
      style={{
        padding: "0px 0px 20px 0px",
        // marginTop: (!mobile && !tab) ? "88px" : "unset",
        marginLeft: !mobile && !tab ? "240px" : "unset",
      }}
    >
      <div className="container">
        <div
          className="section-title custom-text-center"
          style={{ marginBottom: "10px" }}
        >
          <h2 className="section-title__title custom-user-section-title">
            Edit Member
          </h2>
        </div>
        <div className="row">
          {userData?.data?.roles[0]?.name === "sa" && (
            <div className="user-card__header">
              <div
                className="user-card__info"
                style={{ marginLeft: "unset", textAlign: "end" }}
              >
                <button
                  onClick={() => navigate(-1)}
                  className="thm-btn become-volunteer__btn"
                >
                  <i className="icon-arrow-left2"></i>
                  Back
                </button>
              </div>
            </div>
          )}
          <div className="col-xl-4">
            <div className="quality-work__tab-box tabs-box">
              <div
                className="donation-details__presentation custom-feature-two__single"
                style={{
                  padding: "0px",
                  backgroundColor: "transparent",
                  height: "auto",
                }}
              >
                <div className="user-card">
                  <div className="user-card__header">
                    <div className="user-card__image">
                      {profilePicData !== null &&
                      profilePicData !== undefined ? (
                        <img
                          src={
                            profilePicData.attributes.url &&
                            `${process.env.REACT_APP_strapiUrl}${profilePicData.attributes.url}`
                          }
                          alt="User"
                        />
                      ) : (
                        <img src={photo} alt="User" />
                      )}
                      <div
                        className="edit-profil-pic-icon"
                        onClick={handleEditClick}
                      >
                        <span className="icon-pencil"></span>
                      </div>
                    </div>
                    <input
                      type="file"
                      accept="image/*"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />
                    <div className="user-card__info">
                      <h3>{listMemberData[0]?.attributes?.First_Name}</h3>
                      <p className="user-card__designation">
                        {listMemberData[0]?.attributes?.Designation}
                      </p>
                    </div>
                    {/* {userData?.data?.roles[0]?.name === "member" && (
                      <div className={`user-card__status ${mobile && "mt-2"}`}>
                        <div>
                          Status:{" "}
                          <div
                            className="statu-chip"
                            style={getMembershipStatusColor(
                              listMemberData[0]?.attributes?.Status,
                            )}
                          >
                            {listMemberData[0]?.attributes?.Status}
                          </div>
                        </div>
                      </div>
                    )} */}
                  </div>
                  {userData?.data?.roles[0]?.name === "sa" && (
                    <>
                      <div className="col-xl-12" style={{ width: "100%" }}>
                        <StatusDropDown
                          label="Status*"
                          value={status || ""}
                          onChange={(val: any) => {
                            setApprovalStatus(val);
                            setOpenConfirmation(true);
                          }}
                          options={[
                            "Status*",
                            "Pending",
                            "Approved",
                            "Active",
                            "Rejected",
                            "Expired",
                          ]}
                        />
                      </div>
                    </>
                  )}
                  <hr />
                  <div className="user-card__details">
                    <p>
                      <strong>Email:</strong>{" "}
                      <span>{listMemberData[0]?.attributes?.Email}</span>
                    </p>
                    <p>
                      <strong>Phone:</strong>{" "}
                      <span>
                        {listMemberData[0]?.attributes?.Mobile_Number}
                      </span>
                    </p>
                    <p>
                      <strong>Address:</strong>{" "}
                      <span>{listMemberData[0]?.attributes?.City}</span>
                    </p>
                    <p>
                      <strong>Qualifications:</strong>{" "}
                      <span>
                        {listMemberData[0]?.attributes?.Qualifications}
                      </span>
                    </p>
                    <p>
                      <strong>Professional Affiliations:</strong>{" "}
                      <span>
                        {
                          listMemberData[0]?.attributes
                            ?.Professional_Affiliations
                        }
                      </span>
                    </p>
                    <p>
                      <strong>Membership Type:</strong>{" "}
                      <span>{listMemberData[0]?.attributes?.Type_Of_Membership}</span>
                    </p>
                    <p>
                      <strong>Membership Expiry:</strong>{" "}
                      <span>
                        {listMemberData[0]?.attributes?.Membership_Valid === 0
                          ? "Life Time"
                          : (listMemberData[0]?.attributes?.Membership_Expiry ??
                            "-")}
                      </span>
                    </p>
                  </div>
                  <div className="user-tabs">
                    <ul className="user-tabs__menu">
                      <li
                        className={activeTab === "personal" ? "active" : ""}
                        onClick={() => setActiveTab("personal")}
                      >
                        <i className="fas fa-user"></i> Personal Information
                      </li>
                      <li
                        className={activeTab === "contact" ? "active" : ""}
                        onClick={() => setActiveTab("contact")}
                      >
                        <i className="fas fa-phone-alt"></i> Contact Information
                      </li>
                      <li
                        className={activeTab === "operations" ? "active" : ""}
                        onClick={() => setActiveTab("operations")}
                      >
                        <i className="fas fa-heartbeat"></i> Operations
                      </li>
                      <li
                        className={activeTab === "uploads" ? "active" : ""}
                        onClick={() => setActiveTab("uploads")}
                      >
                        <i className="fas fa-file-alt"></i> Uploads
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-xl-8"
            style={{ marginTop: mobile || tab ? "10px" : "unset" }}
          >
            <div className="quality-work__tab-box tabs-box">
              <div
                className="donation-details__presentation custom-feature-two"
                style={{ padding: "16px", backgroundColor: "transparent" }}
              >
                <div className="row">
                  {activeTab === "personal" && (
                    <PersonalInformation
                      firstname={firstname}
                      setFirstname={setFirstname}
                      middlename={middlename}
                      setMiddlename={setMiddlename}
                      lastname={lastname}
                      setLastname={setLastname}
                      age={age}
                      setAge={setAge}
                      sex={sex}
                      setSex={setSex}
                      designation={designation}
                      setDesignation={setDesignation}
                      qualifications={qualifications}
                      setQualifications={setQualifications}
                      professionalAffiliations={professionalAffiliations}
                      setProfessionalAffiliations={setProfessionalAffiliations}
                      memberId={memberId}
                    />
                  )}
                  {activeTab === "contact" && (
                    <ContactInformation
                      mobilenumber={mobilenumber}
                      setMobileNumber={setMobileNumber}
                      whatsappnumber={whatsappnumber}
                      setWhatsappNumber={setWhatsappNumber}
                      permanentAddress={permanentAddress}
                      setPermanentAddress={setPermanentAddress}
                      city={city}
                      setCity={setCity}
                      stateProvince={stateProvince}
                      setStateProvince={setStateProvince}
                      postalZipCode={postalZipCode}
                      setPostalZipCode={setPostalZipCode}
                      country={country}
                      setCountry={setCountry}
                      workAddress={workAddress}
                      setWorkAddress={setWorkAddress}
                      workCity={workCity}
                      setWorkCity={setWorkCity}
                      workStateProvince={workStateProvince}
                      setWorkStateProvince={setWorkStateProvince}
                      workPostalZipCode={workPostalZipCode}
                      setWorkPostalZipCode={setWorkPostalZipCode}
                      workCountry={workCountry}
                      setWorkCountry={setWorkCountry}
                      memberId={memberId}
                    />
                  )}
                  {activeTab === "operations" && (
                    <OperationInfromation
                      listMemberData={listMemberData}
                      memberId={memberId}
                      getUserById={getUserById}
                    />
                  )}
                  {activeTab === "uploads" && (
                    <Uploads
                      listMemberData={listMemberData}
                      memberId={memberId}
                      getUserById={getUserById}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <StatusConfirmation
        open={openConfirmation}
        setOpen={setOpenConfirmation}
        onChange={changeStatus}
        approvalStatus={approvalStatus}
        rejectionReason={rejectionReason}
        setRejectionReason={setRejectionReason}
      />
    </section>
  );
};

export default EditMember;
